import { TimeStampedDocument } from "../types";
import { Topic } from "../topics/topics";
import { User } from "../users/users";

export interface Conversation extends TimeStampedDocument {
  _id: string;
  /** Date to start */
  date: string;
  /** Latency, in seconds */
  latencySeconds: number;
  /** Conversation start time */
  startTime: string;
  /** Conversation end time */
  endTime: string;
  /** Conversation Mode */
  mode: ConversationMode;
  /** Topics - optional */
  topics?: Topic[];
  /** Partipants - optional */
  participants?: Participant[];
}

export enum ConversationMode {
  VOICE = "voice",
  MESSAGE = "message"
}

/** Join table Conversations to Users */
export interface Participant {
  /** Will be full conversation model if populated */
  conversation: Conversation;
  /** Will be full user model if populated */
  user: User;
  /** Whether this user created the conversation */
  creator: boolean;
  /** Has the user accepted the conversation */
  accepted?: boolean;
}
